import { ErrorHandler, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AngularPlugin } from '@microsoft/applicationinsights-angularplugin-js';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InsightsService {
    private angularPlugin = new AngularPlugin();
    private appInsights: ApplicationInsights;
 
    constructor(private router: Router) {
        this.appInsights = new ApplicationInsights({
          config: {
              connectionString: environment.appInsights.connectionString,
              disablePageUnloadEvents: ["unload"],
              extensions: [this.angularPlugin],
              extensionConfig: {
                  [this.angularPlugin.identifier]: {
                      router: this.router,
                      errorServices: [new ErrorHandler()],
                  },
              },
          },
      });
        this.appInsights.loadAppInsights();
    }
 
    // expose methods that can be used in components and services
    trackEvent(name: string): void {
        this.appInsights.trackEvent({ name });
    }

    trackPageView(name: string, uri: string): void {
      this.appInsights.trackPageView({ name , uri });
    }
 
    trackTrace(message: string): void {
        this.appInsights.trackTrace({ message });
    }
}
